define(['jquery', 'enhancedEcommerce', 'app', 'siteObj'], function($, enhancedEcommerce, app, siteObj) {
  'use strict';
  var quickViewTracking = {

    addTracking: function() {

      var $buyButton;
      var buttonClass;
      switch (
      $('.js-product-quick-view .product-variations, .js-product-quick-view .product-variation').length ? true : false) {
        case true:
          $buyButton = $('.product-quick-view .js-buynow');
          buttonClass = 'js-buynow';
          break;
        case false:
          $buyButton = $('.product-quick-view .productbuy');
          buttonClass = 'productbuy';
          break;
      }

      if ($buyButton.length && siteObj.features.enhancedEcommerce === 'true') {
        try {
          $buyButton.on({
            click: function(e) {
              if ($buyButton.hasClass('disabled') !== true) {
                enhancedEcommerce.sendValues(e, buttonClass, 'addToCart', 'add');
              }
            }
          });
        } catch (e) {
          app.publish('tracking/record', 'gtmEventsError', 'add to cart', e.message);
        }
      }
    },
    removeTracking: function() {
      var $buyButton = $('.product-quick-view .productbuy');
      $buyButton.off();
    },
    getData: function($cItem, config) {
      var $eeDataObj = $cItem[0].querySelectorAll('.js-enhanced-ecommerce-data')[0];

      if ($eeDataObj) {
        config.index = $eeDataObj.getAttribute('data-product-position');
        config.id = $eeDataObj.getAttribute('data-product-id');
        config.isMasterProduct = $eeDataObj.getAttribute('data-product-is-master-product-id');
        config.masterProductId = $eeDataObj.getAttribute('data-product-master-product-id');
        config.brand = $eeDataObj.getAttribute('data-product-brand');
      }

      return config;
    }
  };

  return quickViewTracking;
});
